import i18n from '../../../i18n';
import {isEmpty, isInteger} from 'lodash';
import {isHour} from "../../../data/shared/validators";
import moment from 'moment'

export const validate = values => {
    let errors = {};

    date(values, errors);
    people(values, errors);
    from(values, errors);
    to(values, errors);
    time(values, errors);

    return errors;
};

const date = (values, errors) => {
    if (isEmpty(values.date)) {
        return errors.date = i18n.t('booking.validation_date');
    }
    if (moment(values.date) <=  moment().add(1, 'days')) {
        return errors.date = i18n.t('booking.validation_invalid_date');
    }
};

const from = (values, errors) => {
    if (!validateFromTo('from', values.from)) {
        errors.from = i18n.t('booking.validation_bag_transport_from');
    }
};

const to = (values, errors) => {
    if (!validateFromTo('to', values.to)) {
        errors.to = i18n.t('booking.validation_bag_transport_to');
    }
};

const people = (values, errors) => {
    if (!isInteger(values.people) || values.people <= 0) {
        return errors.people = i18n.t('booking.validation_people_count');
    }
};
const validateFromTo = (field, value) => {
    if(value) {
        const {firstInput, secondInput} = value;

        if (null == firstInput) {
            return false;
        }

        if ('stop' == firstInput.type) {
            return true;
        }

        if (null !== secondInput && 'stop' == secondInput.type) {
            return true;
        }
    }
    return false;
};

const time = (values, errors) => {
    if (isEmpty(values.hour)) {
        errors.hour = "Vous devez indiquer l'heure"
    } else if (!isHour(values.hour)) {
        errors.hour =  "L'heure doit être au format hh:mm"
    }
}

